import { memo, useEffect, useState, Dispatch, SetStateAction } from 'react'
import { ButtonGroup, IconButton, useMediaQuery } from '@chakra-ui/react'
import { CardsVisualization, TableVisualization } from 'components/icons'
import { getLocalStorage, setLocalStorage } from 'utils/storage/localStorage'

type Props = {
  storageKey: string
  setVisualizationType?: Dispatch<SetStateAction<string>>
}

function VisualizationTypeButtons({ storageKey, setVisualizationType }: Props) {
  const [isMobile] = useMediaQuery('(max-width: 800px)')
  const [activeType, setActiveType] = useState<string>('')

  function onSelect(value: string) {
    setActiveType(value)
    if (setVisualizationType) setVisualizationType(value)
    setLocalStorage({ key: storageKey, value: value })
  }

  useEffect(() => {
    const visualizationTypeStorage = getLocalStorage(storageKey)
    if (visualizationTypeStorage) {
      setActiveType(visualizationTypeStorage.toString())
    } else {
      if (isMobile) {
        setLocalStorage({ key: storageKey, value: 'cards' })
        setActiveType('cards')
      } else {
        setLocalStorage({ key: storageKey, value: 'table' })
        setActiveType('table')
      }
    }
  }, [])

  return (
    <ButtonGroup size="sm" spacing={1} variant="outline">
      <IconButton
        variant={activeType === 'cards' ? 'solid' : 'outline'}
        onClick={() => onSelect('cards')}
        icon={<CardsVisualization />}
        aria-label="Ícone de cartões"
        w="32px"
      />
      <IconButton
        variant={activeType === 'table' ? 'solid' : 'outline'}
        onClick={() => onSelect('table')}
        icon={<TableVisualization />}
        aria-label="Ícone de tabela"
        w="32px"
      />
    </ButtonGroup>
  )
}

export default memo(VisualizationTypeButtons)
